/**
 * Collection & search product grid.
 *
 * Paging follows the "Load more style" section setting:
 *   auto_scroll    infinite scroll, an IntersectionObserver pulls the next page in
 *   load_more_btn  a button the shopper clicks, with a progress read-out
 *   pagination     plain page links, nothing is fetched
 *
 * Pages come in through the Section Rendering API (?sections=) instead of a full
 * page load, and ?page= is kept in the URL, so a refresh, a shared link or a back
 * navigation from a PDP rebuilds the same grid.
 */

function resize_promo(){
  if(document.querySelectorAll('.snippet-promo-image.desk-promo')) document.querySelectorAll('.snippet-promo-image.desk-promo').forEach((promo) => {
    setTimeout(() => {
      let prev = promo.previousSibling;
      if(prev){
        if(prev.classList && prev.classList.contains('product-item')){
          promo.style.height = ((prev.clientHeight*2+32) - prev.querySelector('.grid-meta').clientHeight) +'px';
        }
      }
    }, 800);
  })
  let grid = document.querySelector(".collection-grid");
  if(!grid) return;
  document.querySelectorAll('.product-item').forEach((desk_grid) => {
      desk_grid.classList.remove('coll-grid-desk-space');
  });
  let products = Array.from(grid.querySelectorAll(".product-item"));
  let productsPerRow = parseInt(grid.getAttribute("data-desk"), 10) || 6;
  let visibleCount = 0;
  products.forEach((product) => {
      if (product.style.display !== "none") {
          visibleCount++;
          let productRect = product.getBoundingClientRect();
          if ((visibleCount - 1) % productsPerRow === 0 || productRect.left === 0) {
              product.classList.add("coll-grid-desk-space");
          }
      }
  });
  document.dispatchEvent(new
  CustomEvent("swym:collections-loaded"));

  let images = document.querySelectorAll(".product-images img:not(.second-image)");
  images.forEach((img) => {
    if(img.complete){
      img.classList.add("loaded");
    }else{
      img.addEventListener("load", () => img.classList.add("loaded"));
    }
  });

}

function quick_buy_btn(){
  quickAddButton();
  document.querySelectorAll('.quick_view_button').forEach((quickBtn) => {
    if(quickBtn.dataset.quickViewBound === 'true') return;
    quickBtn.dataset.quickViewBound = 'true';
    quickBtn.addEventListener('click',function(e){
      e.preventDefault();
      e.stopImmediatePropagation();
      let url = quickBtn.getAttribute('data-url');
      let modal = quickBtn.getAttribute('data-modal');
      fetch(url)
      .then((response) => response.text())
      .then((response) => {
        const html = new DOMParser().parseFromString(response, 'text/html');
        const source = html.getElementById('section-quick-buy');
        document.body.classList.add('open-quick-buy');
        document.getElementById(modal).getElementsByClassName('quick-buy-popup')[0].innerHTML = source.innerHTML;
        addToCart();
      })
      .catch((e) => {console.error(e);})
    })
  })
  resize_promo();
}

/* ---------- resort sale products to end (search page only) ---------- */

function resortSaleProducts() {
  const grid = document.querySelector('#product-grid');
  if (!grid) return;
  const items = Array.from(grid.querySelectorAll(':scope > .product-item'));
  if (!items.some(el => el.hasAttribute('data-sale'))) return;
  const nonSale = items.filter(el => el.dataset.sale !== 'true');
  const onSale  = items.filter(el => el.dataset.sale === 'true');
  [...nonSale, ...onSale].forEach(el => grid.appendChild(el));
  if (typeof resize_promo === 'function') resize_promo();
}

/* =========================================================================
   Paging engine
   ========================================================================= */

(function () {
  'use strict';

  const MOBILE_BREAKPOINT = 992;
  const MOBILE_COLUMNS = 2;

  let observer = null;
  let isLoading = false;
  let backfilled = false;

  /* ---------- element lookups (the grid is re-rendered by filter.js, so
                nothing is cached between calls) ---------- */

  const gridRoot     = () => document.getElementById('collection-grid');
  const productGrid  = () => document.getElementById('product-grid');
  const moreWrap     = () => document.querySelector('.coll-more-scroll');
  const trigger      = () => document.querySelector('.coll-more-scroll [data-load-more]');

  function loadMode() {
    const wrap = moreWrap();
    if (wrap && wrap.dataset.loadMode) return wrap.dataset.loadMode;
    const section = document.querySelector('[data-section-id][data-load-mode]');
    return (section && section.dataset.loadMode) || 'auto_scroll';
  }

  function sectionId() {
    const root = gridRoot();
    return (root && root.dataset.id) || '';
  }

  function productsPerRow() {
    if (window.innerWidth < MOBILE_BREAKPOINT) return MOBILE_COLUMNS;
    const grid = productGrid();
    return parseInt(grid && grid.dataset.desk, 10) || 4;
  }

  /* ---------- identity, so a product or promo is never appended twice ---------- */

  function productKey(node) {
    if (node.dataset.productId) return node.dataset.productId;
    if (node.dataset.id) return node.dataset.id;
    const link = node.querySelector('a[href]');
    if (!link) return '';
    try {
      return new URL(link.getAttribute('href'), window.location.origin).pathname;
    } catch (e) {
      return link.getAttribute('href') || '';
    }
  }

  const promoKey = (node) => node.dataset.promoId || '';

  /* ---------- fetching ---------- */

  const parseDoc = (html) => new DOMParser().parseFromString(html, 'text/html');

  /**
   * Ask Shopify for just this section rather than the whole page. Falls back to a
   * full document fetch when the Section Rendering API can't serve the request.
   */
  function fetchPage(url) {
    const id = sectionId();
    const plain = () => fetch(url).then((response) => response.text()).then(parseDoc);
    if (!id) return plain();

    const target = new URL(url, window.location.origin);
    target.searchParams.set('sections', id);

    return fetch(target.toString())
      .then((response) => response.json())
      .then((payload) => {
        const html = payload && payload[id];
        if (!html) throw new Error('Section missing from response');
        return parseDoc(html);
      })
      .catch(plain);
  }

  /* ---------- grid mutations ---------- */

  function appendItems(doc, position) {
    const grid = productGrid();
    if (!grid) return 0;

    const seen = new Set();
    grid.querySelectorAll('.product-item').forEach((item) => {
      const key = productKey(item);
      if (key) seen.add(key);
    });
    grid.querySelectorAll('.snippet-promo-image').forEach((promo) => {
      const key = promoKey(promo);
      if (key) seen.add('promo:' + key);
    });

    const products = document.createDocumentFragment();
    let added = 0;

    doc.querySelectorAll('.collection-grid .product-item').forEach((item) => {
      const key = productKey(item);
      if (key && seen.has(key)) return;
      if (key) seen.add(key);
      products.appendChild(item);
      added++;
    });

    /* the grid is laid out as products, then loading skeletons, then promo tiles —
       keep new products ahead of the skeletons so that order survives */
    const firstSkeleton = grid.querySelector(':scope > .blank-span');
    if (position === 'prepend') {
      grid.insertBefore(products, grid.firstChild);
    } else if (firstSkeleton) {
      grid.insertBefore(products, firstSkeleton);
    } else {
      grid.appendChild(products);
    }

    doc.querySelectorAll('.snippet-promo-image').forEach((promo) => {
      const key = promoKey(promo);
      if (key && seen.has('promo:' + key)) return;
      if (key) seen.add('promo:' + key);
      promo.style.display = 'none';
      grid.appendChild(promo);
    });

    return added;
  }

  /**
   * Promo tiles are placed by CSS grid-row, so all this has to do is reveal the
   * ones whose row has been loaded. The desktop/mobile pair is filtered by CSS.
   */
  function placePromos() {
    const grid = productGrid();
    if (!grid) return;

    const perRow = productsPerRow();
    /* only complete rows count, so a promo never opens a gap below the last product */
    const loadedRows = Math.floor(grid.querySelectorAll('.product-item').length / perRow);

    grid.querySelectorAll('.snippet-promo-image').forEach((promo) => {
      const attribute = promo.classList.contains('mb-promo') ? 'data-mob-row' : 'data-desk-row';
      const row = parseInt(promo.getAttribute(attribute), 10);
      promo.style.display = (!isNaN(row) && row <= loadedRows) ? 'block' : 'none';
    });
  }

  /* ---------- read-outs ---------- */

  /** Mirror the "24 of 132" line and its progress bar from the freshly fetched page. */
  function syncProgress(doc) {
    const liveCount = document.querySelector('.coll-load-more-count');
    const newCount  = doc.querySelector('.coll-load-more-count');
    if (liveCount && newCount) {
      liveCount.textContent = newCount.textContent;
      liveCount.dataset.countShown = newCount.dataset.countShown || '';
      liveCount.dataset.countTotal = newCount.dataset.countTotal || '';
    }

    const liveFill = document.querySelector('.coll-load-more-bar-fill');
    const newFill  = doc.querySelector('.coll-load-more-bar-fill');
    if (liveFill && newFill) liveFill.style.width = newFill.style.width;

    announce();
  }

  /** Tell screen readers how much of the collection is on screen. */
  function announce() {
    const status = document.querySelector('.coll-more-status');
    const grid = productGrid();
    if (!status || !grid) return;

    const template = status.dataset.statusTemplate;
    if (!template) return;

    const shown = grid.querySelectorAll('.product-item').length;
    const total = grid.dataset.count || shown;
    status.textContent = template.replace('[count]', shown).replace('[total]', total);
  }

  /* ---------- URL ---------- */

  /** Keep ?page= in step with what has been loaded, without adding history entries. */
  function syncPageInUrl(loadedUrl) {
    let page;
    try {
      page = new URL(loadedUrl, window.location.origin).searchParams.get('page');
    } catch (e) {
      return;
    }
    if (!page) return;

    const current = new URL(window.location.href);
    current.searchParams.set('page', page);
    /* history.state is left intact so filter.js keeps its own popstate payload */
    window.history.replaceState(window.history.state, '', current.toString());

    const wrap = moreWrap();
    if (wrap) wrap.dataset.currentPage = page;
    const grid = productGrid();
    if (grid) grid.dataset.currentPage = page;
  }

  /* ---------- loading the next page ---------- */

  function refreshGridUi() {
    placePromos();
    if (typeof quick_buy_btn === 'function') quick_buy_btn();
    resortSaleProducts();
  }

  function loadNextPage() {
    const button = trigger();
    if (!button || isLoading) return Promise.resolve();

    const nextUrl = button.getAttribute('href');
    if (!nextUrl) return Promise.resolve();

    isLoading = true;
    const wrap = moreWrap();
    if (wrap) wrap.classList.add('loading');
    button.classList.add('is-loading');

    return fetchPage(nextUrl)
      .then((doc) => {
        appendItems(doc, 'append');
        syncProgress(doc);
        syncPageInUrl(nextUrl);

        const nextTrigger = doc.querySelector('.coll-more-scroll [data-load-more]');
        if (nextTrigger && nextTrigger.getAttribute('href')) {
          button.setAttribute('href', nextTrigger.getAttribute('href'));
        } else {
          /* last page reached */
          if (observer) observer.disconnect();
          button.remove();
        }

        refreshGridUi();
      })
      .catch((error) => {
        console.error('Error loading products:', error);
      })
      .finally(() => {
        isLoading = false;
        if (wrap) wrap.classList.remove('loading');
        button.classList.remove('is-loading');
      });
  }

  /* ---------- infinite scroll ---------- */

  function initAutoScroll() {
    if (observer) observer.disconnect();

    const sentinel = trigger();
    if (!sentinel) return;

    /* rootMargin rather than a threshold: the sentinel has no height, and starting
       the fetch a screenful early keeps scrolling uninterrupted */
    observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !isLoading) loadNextPage();
      });
    }, { rootMargin: '600px 0px' });

    observer.observe(sentinel);
  }

  /* ---------- deep links into the middle of a collection ---------- */

  /**
   * Landing on ?page=4 renders only that slice. Pull pages 1..3 in and prepend them
   * so the grid is whole, holding the viewport still while the content grows above.
   */
  function backfillPreviousPages() {
    const grid = productGrid();
    if (!grid) return Promise.resolve();

    const currentPage = parseInt(grid.dataset.currentPage, 10) || 1;
    if (currentPage <= 1) return Promise.resolve();

    const requests = [];
    for (let page = 1; page < currentPage; page++) {
      const url = new URL(window.location.href);
      url.searchParams.set('page', String(page));
      requests.push(fetchPage(url.toString()));
    }

    return Promise.all(requests)
      .then((docs) => {
        const scrollBefore = window.pageYOffset;
        const heightBefore = document.documentElement.scrollHeight;

        /* prepend back to front so page 1 ends up first */
        docs.reverse().forEach((doc) => appendItems(doc, 'prepend'));

        const heightAfter = document.documentElement.scrollHeight;
        window.scrollTo(0, scrollBefore + (heightAfter - heightBefore));

        refreshGridUi();
      })
      .catch((error) => {
        console.error('Error loading previous pages:', error);
      });
  }

  /* ---------- scroll position across a PDP visit ---------- */

  const scrollKey = () => 'coll-scroll:' + window.location.pathname + window.location.search;

  function rememberScroll() {
    /* pagination renders whole pages, so the browser restores the scroll itself */
    if (loadMode() === 'pagination') return;
    try {
      sessionStorage.setItem(scrollKey(), String(window.scrollY));
    } catch (e) { /* private mode / quota */ }
  }

  /** Reads and clears the position saved before the shopper left for a PDP. */
  function takeSavedScroll() {
    try {
      const saved = sessionStorage.getItem(scrollKey());
      sessionStorage.removeItem(scrollKey());
      return saved === null ? null : parseInt(saved, 10);
    } catch (e) {
      return null;
    }
  }

  document.addEventListener('click', (event) => {
    if (event.target.closest('#product-grid a, .snippet-promo-image a')) rememberScroll();
  });

  /* ---------- click handling for the load more button ---------- */

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.coll-more-scroll [data-load-more]');
    if (!button) return;
    event.preventDefault();
    loadNextPage();
  });

  /* ---------- init, also re-run by filter.js after a filter or sort ---------- */

  function load_more() {
    if (observer) {
      observer.disconnect();
      observer = null;
    }
    isLoading = false;

    const grid = productGrid();
    if (!grid) return;
    const mode = loadMode();

    placePromos();

    if (mode === 'pagination') {
      backfilled = true;
      return;
    }

    if (mode === 'auto_scroll') initAutoScroll();

    /* everything below is first-load only; filter.js re-runs this on every filter
       change and always lands back on page 1 */
    if (backfilled) {
      announce();
      return;
    }
    backfilled = true;

    const savedScroll = takeSavedScroll();
    const needsBackfill = (parseInt(grid.dataset.currentPage, 10) || 1) > 1;

    /* the browser restores the pre-navigation scroll before the backfill has grown
       the page, so take that over ourselves — but only when there is something to
       restore, otherwise leave the default alone */
    if ((savedScroll !== null || needsBackfill) && 'scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }

    backfillPreviousPages().then(() => {
      if (savedScroll !== null) {
        requestAnimationFrame(() => window.scrollTo(0, savedScroll));
      }
      announce();
    });
  }

  /* the theme editor re-renders the section in place when a setting changes, which
     leaves the observer watching a detached sentinel */
  document.addEventListener('shopify:section:load', (event) => {
    if (!event.target.querySelector('#product-grid')) return;
    backfilled = true;
    load_more();
    if (typeof quick_buy_btn === 'function') quick_buy_btn();
  });

  window.load_more = load_more;
})();

/* =========================================================================
   Collection chrome: grid view switch, sticky title
   ========================================================================= */

document.addEventListener('DOMContentLoaded', () => {
  load_more();
  resortSaleProducts();

  const activeView = document.querySelector('.coll-view a[data-view].active');
  const grid = document.querySelector('.collection-grid');
  if (activeView && grid) {
    if (localStorage.getItem('collection_grid') == null) {
      localStorage.setItem('collection_grid', activeView.getAttribute('data-view'));
    } else {
      const stored = localStorage.getItem('collection_grid');
      grid.setAttribute('data-desk', stored);
      if (activeView.getAttribute('data-view') !== stored) {
        activeView.classList.remove('active');
        document.querySelectorAll('.coll-view a[data-view]').forEach((view) => {
          if (parseInt(view.getAttribute('data-view'), 10) === parseInt(stored, 10)) {
            view.classList.add('active');
          }
        });
      }
    }
  }

  document.querySelectorAll('.coll-view a[data-view]').forEach((view) => {
    view.addEventListener('click', (e) => {
      e.preventDefault();
      localStorage.setItem('collection_grid', view.getAttribute('data-view'));
      const productGrid = document.querySelector('.collection-grid');
      if (productGrid) productGrid.setAttribute('data-desk', localStorage.getItem('collection_grid'));
      document.querySelectorAll('.coll-view a[data-view].active').forEach((active) => active.classList.remove('active'));
      view.classList.add('active');
      resize_promo();
    });
  });

  const collTitle = document.querySelector('.coll-title');
  if (collTitle) {
    collTitle.addEventListener('click', (e) => {
      e.preventDefault();
      if (document.body.classList.contains('sticky-filter')) {
        document.body.classList.toggle('open-subcoll');
        document.body.classList.remove('open-sort', 'open-drawer', 'open-menu', 'open-search', 'open-filter');
      }
    });
  }

  resize_promo();
});

window.addEventListener('resize', resize_promo);
